import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { Drawer as ElDrawer } from 'element-ui';
import ListingMenu from './ListingMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListingMenuSp',
  props: {
    initialQuery: null,
    initialCategory: null,
    initialSubCategory: null,
    initialFromPrice: null,
    initialToPrice: null,
    initialMaterial: null,
    initialColor: null,
    initialGift: null,
    initialOrdermade: null,
    initialVintage: null,
    initialSelling: null,
    sort: null,
    order: null
  },
  setup(__props: any) {


const isShow = ref(false);

return { __sfc: true,isShow, ElDrawer, ListingMenu }
}

})